import { render, staticRenderFns } from "./beneficiary-home-phone-popover.vue?vue&type=template&id=c9219c66&"
import script from "./beneficiary-home-phone-popover.vue?vue&type=script&lang=js&"
export * from "./beneficiary-home-phone-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports